<script setup lang="ts">
import type { PrimitiveProps } from "reka-ui";
import { Primitive } from "reka-ui";
import type { HTMLAttributes } from "vue";
import type { CardVariants } from ".";
import { cardVariants } from ".";
import { cn } from "@/lib/utils";

interface Props extends /* @vue-ignore */ PrimitiveProps {
  shadow?: CardVariants["shadow"];
  border?: CardVariants["border"];
  clickable?: boolean;
  class?: HTMLAttributes["class"];
}

const props = withDefaults(defineProps<Props>(), {
  shadow: "sm",
  border: "default",
  clickable: false,
  class: undefined,
});
</script>

<template>
  <Primitive
    data-slot="card"
    :data-clickable="props.clickable ? 'true' : undefined"
    :class="
      cn(
        cardVariants({
          shadow: props.shadow,
          border: props.border,
          // @ts-ignore - clickable variant expects boolean but receives string
          clickable: props.clickable ? 'true' : 'false',
        }),
        props.class,
      )
    "
  >
    <slot />
  </Primitive>
</template>
